<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="card shadow">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center">Privacy Policy</h3>
        </div>
        <div class="card-body">
          <!-- Introduction Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Introduction</h4>
            <p>
              If you have any questions about this policy, contact us at: <strong>{{'support@smartdukaan.com'}}</strong>
            </p>
            <br>
            <p>
              <strong>New Spice Solutions Pvt Ltd ("NSSPL", "We", "Us", "Smartdukaan")</strong> is committed to the compliance of applicable Privacy Laws in the country where Smartdukaan's product is distributed. Protecting the privacy and security of your personal data is of prime importance to Us, therefore, we conduct our business by abiding by the laws applicable on data privacy and data security in the country where Smartdukaan's product is distributed to you.
            </p>
            <br>
            <p>
              This Privacy Policy is intended to inform you about the personal data that is collected from you, how your personal data may be used and disclosed, how you can control the use of your personal data, and how your personal data is protected when you use the Smartdukaan Web Application. We do not sell or trade your personally identifiable information; however, we may share it with third parties who assist us in conducting our business, operating our website/Application, or servicing you, as long as those parties agree to keep this information confidential.
            </p>
          </section>

          <!-- Personal Information We Collect Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Personal Information We Collect</h4>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li>Name</li>
              <li>Phone Number</li>
              <li>Email Address</li>
              <li>Postal Address</li>
              <li>IP Address</li>
              <li>Browser type and operating system</li>
              <li>Pages visited and links clicked</li>
              <li>Bandwidth speed</li>
              <li>Software programs installed on your device</li>
              <li>Standard server log information</li>
            </ul>

            <h4 class="text-danger mt-4">Information you provide directly:</h4>
            <p>When you use certain functions such as registering for services or accessing features, we may ask for data such as name, contact number, address, email, username, password, etc.</p>

            <h4 class="text-danger mt-4">Information automatically collected when you use the Application:</h4>
            <p>We may automatically collect data like your IP address, browser type, visited pages, ads viewed, and other device or usage data.</p>

            <h4 class="text-danger mt-4">Information from Other Sources:</h4>
            <p>We may receive information about you from public/commercial sources (as permitted by law), and from third-party services you choose to connect with (e.g., social media).</p>
          </section>

          <!-- How We Use Your Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">How We Use Your Information</h4>
            <p>We may use your data to:</p>
            <ul>
              <li>Register you or your device for services</li>
              <li>Deliver requested features or services</li>
              <li>Send updates and promotional communications (with consent)</li>
              <li>Create statistics and usage trends</li>
              <li>Improve our products and services</li>
              <li>Publish public content you've uploaded (reviews, etc.)</li>
            </ul>
          </section>

          <!-- Disclosure of Personal Data Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Disclosure of Personal Data</h4>
            <ol type="a">
              <li class="mb-2">We may share data with third parties for services like maintenance, marketing, or analytics (who are bound by confidentiality and data protection laws).</li>
              <li class="mb-2">Use of our Application implies acceptance of our and our developers' terms and policies.</li>
              <li>We may also disclose your data when legally required or to protect rights, property, or safety.</li>
            </ol>
          </section>

          <!-- Your Choices Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Your Choices</h4>
            <p>You can opt-out of promotional messages via unsubscribe links or settings. You also control your data in account settings or as per instructions provided.</p>
          </section>

          <!-- Security Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Security</h4>
            <p>We use reasonable physical and technical safeguards to protect your personal data. However, no online system can be 100% secure.</p>
          </section>

          <!-- Links to Other Websites Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Links to Other Websites</h4>
            <p>Our Application may link to other websites. We are not responsible for their content or privacy practices. Please read their privacy policies when visiting.</p>
          </section>

          <!-- Changes to the Privacy Policy Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Changes to the Privacy Policy</h4>
            <p>We may update this policy at any time. Material changes will be highlighted on our website/Application with an updated effective date.</p>
          </section>

          <!-- Contact Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Contact Information</h4>
            <p>For any questions about this privacy policy, please contact us at:</p>
            <ul>

              <li><strong>Email:</strong> {{'care@smartdukaan.com'}}</li>
              <li><strong>Company:</strong> New Spice Solutions Pvt Ltd</li>
              <li><strong>Address:</strong> Priska Tower, 2nd Floor, C-56/45, C Block, Industrial Area Phase 2, Sector 62, Noida - 201309 (UP)</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
